export enum ReconciliationStatus {
  Queued = 'Queued',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
  Unknown = 'Unknown',
}

export enum TransactionStatus {
  Pending = 'Pending',
  Succeded = 'Succeded',
  Failed = 'Failed',
}

export type TransactionRequestParams = {
  offset: number;
  count: number;
};

export type Transaction = {
  id: string;
  paymentId: string;
  createdAt: string;
  number: string;
  captureAmount: number;
  availableCaptureAmount: number;
  message?: string | null;
  status: TransactionStatus;
};

export type Reconciliation = {
  id: string;
  status: ReconciliationStatus;
  createdAt: string;
};

export type CaptureResponse = {
  succeededCount: number;
  failedCount: number;
  totalCount: number;
};
